import axios from "axios";
import Swal from "sweetalert2";
import { t } from "i18next";
import { tokenConfig } from "./websiteActions";

export const createPost = (data) => (dispatch, getState) => {
    return axios
        .post(`/api/posts`, data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success");
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
                return [];
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
            return [];
        });
};

export const updatePost = (data) => (dispatch, getState) => {
    return axios
        .put(`/api/posts`, data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success");
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
                return [];
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
            return [];
        });
};
